import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader'
import ClientCompanyModal from './ClientCompanyModal';
import axios from 'axios';
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts';
import ClientCompanyGrid from './ClientCompanyGrid';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper'
import { logAuditEvent } from '../../utils/auditLogger';

function ClientCompanyMain(props) {
  const [getClientCompanyList, setClientCompanyList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const moduleName = props.Module || 'Client Company';

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchClientCompany();
  }, []);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Client Company');
  }, [moduleName]);

  function openAddModal() {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add client company modal');
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const clientCompanyModel = data;
      if(clientCompanyModel) {
        let clientCompanyDetails = {
          ClientCompanyId: null,
          ClientCompanyName: clientCompanyModel.ClientCompanyName ? clientCompanyModel.ClientCompanyName : "",
          ClientCompanyTypeId: clientCompanyModel.ClientCompanyTypeId ? clientCompanyModel.ClientCompanyTypeId : null,
          Description: clientCompanyModel.Description ? clientCompanyModel.Description : "",
          RMName1: clientCompanyModel.RMName1 ? clientCompanyModel.RMName1 : "",
          RMContact1: clientCompanyModel.RMContact1 ? clientCompanyModel.RMContact1 : "",
          RMName2: clientCompanyModel.RMName2 ? clientCompanyModel.RMName2 : "",
          RMContact2: clientCompanyModel.RMContact2 ? clientCompanyModel.RMContact2 : "",
          RMName3: clientCompanyModel.RMName3 ? clientCompanyModel.RMName3 : "",
          RMContact3: clientCompanyModel.RMContact3 ? clientCompanyModel.RMContact3 : "",
          UserId: getStorageValues('userId')
        };
        if (validation(clientCompanyDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saveClientCompanyDetails",
              clientCompanyDetails
            );
            if (response.status === 200) {
              if(response.data.data[0].success === 1){
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                fetchClientCompany();
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    } 
  }
  function validation(clientCompanyDetails) {
    var validation = true;
    if (clientCompanyDetails) {
      if (clientCompanyDetails.ClientCompanyTypeId !== null) {
        if (clientCompanyDetails.ClientCompanyTypeId.length === 0) {
          CreateAlert("Please select client company type!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please select client company type!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientCompanyDetails.ClientCompanyName !== null) {
        if (clientCompanyDetails.ClientCompanyName.length === 0) {
          CreateAlert("Please enter client company type!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter client company type!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }
  const fetchClientCompany = async () => {
    try {
      let ClientCompanyDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/clientCompanylist", ClientCompanyDetails);
      if (response.status === 200) {
        setClientCompanyList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={false}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false }
      />
      <ClientCompanyGrid ClientCompanyData={getClientCompanyList} fetchClientCompany={fetchClientCompany} UserPermissions={getUserModulePermission}/>
      <ClientCompanyModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}
      />
    </>
  )
}

export default ClientCompanyMain